import PropTypes from "prop-types"
import React from "react"

import Button from "src/components/Button"

import AccountBenefit, { accountBenefitPropType } from "./AccountBenefit"
import AuthInterstitialLayout from "./AuthInterstitialLayout"

const GuestCreateAccountWelcome = ({
  authPhotoUrl,
  offer,
  onCreateAccount,
  onSkip,
}) => {
  const { copy } = offer

  return (
    <AuthInterstitialLayout
      authPhotoUrl={authPhotoUrl}
      header={
        <div className="mb-6 flex h-32 w-full items-center justify-center">
          <img
            src={offer.logoUrl}
            alt={offer.logoAlt}
            className="max-h-full max-w-full object-contain"
          />
        </div>
      }
      title={copy.title}
      subtitle={copy.subtitle}
    >
      <div className="mx-auto flex w-full flex-col items-center text-center xl:w-3/4">
        <ul
          role="list"
          className="my-6 flex w-full list-none flex-col gap-5 rounded-lg border border-gray-300 bg-white p-6 text-left"
        >
          {copy.benefits.map((benefit) => (
            <li key={benefit.title}>
              <AccountBenefit benefit={benefit} />
            </li>
          ))}
        </ul>

        <a
          href={offer.signUpUrl}
          className="btn btn-primary w-full"
          onClick={onCreateAccount}
        >
          {copy.cta}
        </a>
        <p className="mb-0 mt-2 text-sm text-gray-700">{copy.note}</p>

        <div className="mt-3 w-full">
          <Button variant="link" fullWidth onClick={onSkip}>
            {copy.guest}
          </Button>
        </div>
      </div>
    </AuthInterstitialLayout>
  )
}

export const createAccountOfferPropType = PropTypes.shape({
  signUpUrl: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  logoAlt: PropTypes.string.isRequired,
  copy: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    guest: PropTypes.string.isRequired,
    benefits: PropTypes.arrayOf(accountBenefitPropType).isRequired,
  }).isRequired,
})

GuestCreateAccountWelcome.propTypes = {
  authPhotoUrl: PropTypes.string,
  offer: createAccountOfferPropType.isRequired,
  onCreateAccount: PropTypes.func,
  onSkip: PropTypes.func.isRequired,
}

export default GuestCreateAccountWelcome
